import React from 'react';
import { StorePageInnerSection } from './StoreSections';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const StoresNearby = (props) => {
    var _a;
    const { t } = useTranslation();
    const { baseUrl } = useSelector((state) => state.storelocator);
    if (!((_a = props.stores) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (React.createElement("div", { className: "store-page__nearby-list" }, props.stores.map((store) => (React.createElement("div", { className: "store-page__nearby-store", id: `nearby-store-${store.ID}`, key: `nearby-store-${store.ID}` },
        React.createElement(StorePageInnerSection, { title: store.name },
            React.createElement("p", null, store.address1)),
        React.createElement(StorePageInnerSection, { title: t('store.details'), titleTag: "h4" },
            (store.storetype || store.email || store.phone) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "store-page__nearby-infos" },
                    store.storetype && React.createElement("p", { className: "font__subtitle" }, store.storetype),
                    store.phone && (React.createElement("p", null,
                        t('label.phone'),
                        ' ',
                        React.createElement("a", { className: "contact-link", href: `tel:${store.phone}` }, store.phone))),
                    store.email && (React.createElement("p", null,
                        t('label.email'),
                        ' ',
                        React.createElement("a", { className: "contact-link", href: `tel:${store.email}` }, store.email)))))),
            React.createElement("div", { className: "links" },
                React.createElement("a", { className: "button button--tertiary", href: `${baseUrl}/storelocator/${store.slug}` },
                    React.createElement("span", null, t('button.viewdetails'))),
                React.createElement("a", { className: "button button--tertiary", href: `${baseUrl}/storelocator` },
                    React.createElement("span", null, t('store.findothers'))))))))));
};
export default StoresNearby;
